import { throwError } from "@/lib/throwError";
import { del, get, post, put } from "@/services/axiosUitils";
import {
  CreatePermissionPayload,
  Permission,
  UpdatePermissionPayload,
} from "@/utils/types/tenantPermissions";
import { PaginatedResponse } from "@/utils/types/translationHooks";

const permissionsBase = "/tenant-permissions/permissions/";

class TenantPermissionService {
  listPermissions = async (
    page = 1,
    pageSize = 20
  ): Promise<PaginatedResponse<Permission>> => {
    return await get<PaginatedResponse<Permission>>(permissionsBase, {
      params: { page, page_size: pageSize },
    });
  };

  getPermissionByRoleId = async (
    roleId: string,
    schemaName: string,
    page = 1,
    pageSize = 20
  ): Promise<{ results: any[] }> => {
    return await get(
      `${permissionsBase}?role_id=${roleId}&schema_name=${schemaName}&page=${page}&page_size=${pageSize}`
    );
  };

  getPermissionById = async (id: string): Promise<Permission> => {
    if (!id) {
      throwError("ID is required", "TenantPermissionService");
    }
    return await get<Permission>(`${permissionsBase}${id}/`);
  };

  createPermission = async (
    payload: CreatePermissionPayload
  ): Promise<Permission> => {
    if (!payload) {
      throwError("Payload is required", "TenantPermissionService");
    }
    return await post<Permission>(permissionsBase, payload);
  };

  updatePermission = async (
    id: string,
    payload: UpdatePermissionPayload
  ): Promise<Permission> => {
    if (!id || !payload) {
      throwError("ID and payload are required", "TenantPermissionService");
    }
    return await put<Permission>(`${permissionsBase}${id}/`, payload);
  };

  deletePermission = async (id: string): Promise<any> => {
    if (!id) {
      throwError("ID is required", "TenantPermissionService");
    }
    return await del(`${permissionsBase}${id}/`);
  };
}

const instance = new TenantPermissionService();
export default instance;
